<!--  -->
<template>
<div class=''></div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: mapGetters(['website']),
  methods: {
    cas: function() {
      this.$http.post('/integrate/uaap/cas/exchange-token', {},
        {
          'params': {
            'token': this.$route.query.ticket
          }
        }).then(response => {
        this.$store.dispatch('Login', { loginInfo: response.data })
        let toUrl = this.$route.query.toUrl
        if (toUrl) {
          this.$router.push(toUrl)
        } else {
          this.$router.push(this.website.firstPage.value)
        }
      }).catch(error => {
        this.$message.error(error.msg)
      })
      console.info(this.$route.query.ticket)
    }
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.cas()
  }
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类

</style>
